module.exports = __webpack_public_path__ + "img/ez-slot-three-candy.972c04be.png";